var map = {
	"./cs.json": 5765,
	"./de.json": 4972,
	"./en.json": 5450,
	"./hu.json": 2109,
	"./it.json": 5700,
	"./pl.json": 5105,
	"./ro.json": 7432,
	"./sk.json": 7389
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 775;